export const BaseURL = `${process.env.REACT_APP_API_BASE_URL}/entrecomp`

export interface IQuestion{
    question: string,
    answer: string;
}

export const QuestionApi = {
  // fetch: (token: string, callback: (error?: string, question?: IQuestion) => void): void =>{
  //   fetch (`${BaseURL}/Questions?token=${token}`)
  //     .then(res => res.json())
  //     .then(data => callback (undefined, data.map((c: any) => ({
  //       question: c.question,
  //       answer: c.answer,
  //     }))))
  //     .catch(() => callback("Something went wrong."))
  // },
}


export const GetSelfAssessmentForm = (token: string) => {
  return fetch(`${BaseURL}/Questions?token=${token}`).then(response => {
    if (response.ok && response.status === 200) {
      return response.json().then(result => result)
    }
   
  })
}

export const SendSelfAssessment = (token: string, answers: {competencyId: number, score?: number, answerText?: string}[]) => {
  return fetch(`${BaseURL}/Assessments?token=${token}`,
    {
      method: 'POST',
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify({ answers: answers }),
    })
    .then(response => {
      if (response.ok && response.status === 200) {
        return response.json();
      } else {
        return response
      }
    })
}

export const GetSelfAssessment = (token: string, id: string) => {
  return fetch(`${BaseURL}/Assessments/${id}?token=${token}`).then(response => {
    if (response.ok && response.status === 200) {
      return response.json()
    }
  })

}
export const GetSelfAssessments = (token: string) => {
  return fetch(`${BaseURL}/Assessments?token=${token}`).then(response => {
    //console.log(response)
    if (response.ok && response.status === 200) {
      return response.json()
    }
  })

}


export const GetSelfAssessmentCache = (token: string) => {
  return fetch(`${BaseURL}/Assessments/Cache?token=${token}`).then(response => {
    if (response.ok && response.status === 200) {
      return response.json()
    } else {
      return null
    }
  })

}

export const SendSelfAssessmentCache = (token: string, answers: {competencyId: number, score?: number, answerText?: string}[]) => {
  return fetch(`${BaseURL}/Assessments/Cache?token=${token}`,
    {
      method: 'POST',
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify({ answers: answers }),
    })
    .then(response => {
      return response
    })
}